export default __webpack_public_path__ + "static/media/warning--camel-crossing--g1.0fc63ebb.png";